import Cookies from 'js-cookie'

$(document).ready(function() {
  const closeElement = $('.js-cookie-bar-close')

  if (Cookies.get('orkla_cookie_consent') === undefined) {
    $('.js-cookie-bar').toggleClass('d-none')
  }

  closeElement.on('click', function () {
    $('.js-cookie-bar').toggleClass('d-none')
  })

  //Cookies.set('orkla_cookie_consent', true)
})


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/scripts/modules/cookie-bar.js
// module id = 15
// module chunks = 0